import ReactInputVerificationCode from "react-input-verification-code";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import axios from "axios";
import across from "../../imgs/across.png";
import cross from "../../imgs/cross.png";
const Vppopup = () => {
  const veri2 = useSelector((state) => state.veri2);
  const token = useSelector((state) => state.token);
  const universalCheck = useSelector((state) => state.universalCheck);
  const popData = useSelector((state) => state.popData);
  const dispatch = useDispatch();
  const option = useSelector((state) => state.option);
  const [code1, setCode1] = useState("");
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [err, setErr] = useState("");
  const [seconds, setSeconds] = useState(60);
  const [startCountdown, setStartCountdown] = useState(false);
  useEffect(() => {
    if (startCountdown && seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      return () => clearTimeout(timer);
    }
    if (seconds === 0) {
      setShow(false);
      setSeconds(60);
    }
  }, [startCountdown, seconds]);
  const handleStartClick = () => {
    setStartCountdown(true);
  };

  const completeHandler = (e) => {
    setCode1(e);
  };
  
  console.log("OPT", option);
  const checkHandler = () => {
    if (code1 === "") {
      setShow1(true);
      setErr("Please enter the verification code");
    } else if (option === "Merchant") {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/v1/merch-auth/verify-phone`,
          {
            verifyCode: code1,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {
          dispatch({ type: "veri2" });
          if (universalCheck === "both") {
            dispatch({ type: "veri" });
          } else {
            dispatch({ type: "IINCREMENT" });
          }
          setCode1("");
        })
        .catch((err) => {
          setErr(err.response.data.message);
          setShow1(true);
        });
    } else if (option === "Vendor") {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/v1/vendor-auth/verify-phone`,
          {
            verifyCode: code1,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {
          dispatch({ type: "veri2" });
          if (universalCheck === "both") {
            dispatch({ type: "veri" });
          } else {
            dispatch({ type: "RSET", num: 1 });
            dispatch({ type: "IINCREMENT" });
          }
          setCode1("");
        })
        .catch((err) => {
          setErr(err.response.data.message);
          setShow1(true);
        });
    } else {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/v1/auth/verify-phone`,
          {
            verifyCode: code1,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {
          dispatch({ type: "veri2" });
          if (universalCheck === "both") {
            dispatch({ type: "veri" });
          } else {
            dispatch({ type: "IINCREMENT" });
          }
          setCode1("");
        })
        .catch((err) => {
          setErr(err.response.data.message);
          setShow1(true);
        });
    }
  };
  const resendHandler = () => {
    setShow(true);
    handleStartClick();
    if (option === "Merchant") {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/v1/merch-auth/resend-phone-otp`,
          null,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {})
        .catch(() => {});
    } else if (option === "Vendor") {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/v1/vendor-auth/resend-phone-otp`,
          null,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {})
        .catch(() => {});
    } else {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/v1/auth/resend-phone-otp`,
          null,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {})
        .catch(() => {});
    }
  };
  return (
    <div
      className={`fixed top-0 w-full h-full  bg-slate-500/50  justify-center items-center ${
        veri2 ? "flex" : "hidden"
      }`}
    >
      <div className="sm:pt-[2rem] sm:pl-[2.2rem] sm:pr-[2.2rem] md:w-[50%] sm:h-[24rem] lg:pt-[2rem] lg:pl-[2.2rem] lg:pr-[2.2rem] lg:w-[35%] lg:h-[23rem] w-[90%] h-[22rem] bg-white rounded-2xl flex items-center flex-col p-6 pl-5 pr-5 relative">
        <h2 className="mb-[1rem] text-[1.5rem] font-bold">
          Mobile Verification
        </h2>
        <div
          className="absolute top-3 right-4 cursor-pointer"
          onClick={() => {
            dispatch({ type: "veri2" });
          }}
        >
          <img className="scale-[0.8]" src={cross} />
        </div>
        <p className="text-center text-[1rem] mb-[2rem]">
          Please enter the six digit verification code that was sent to &nbsp;
          <span className="font-semibold">{`${popData.countryCode}${popData.phoneNo}`}</span>
        </p>
        <ReactInputVerificationCode
          className="--ReactInputVerificationCode-itemWidth"
          length={6}
          onCompleted={completeHandler}
          value={code1}
        />
        <p
          className={`mt-4 text-center text-[0.85rem] ${show ? "hidden" : ""}`}
        >
          Did not receive the verification code?&nbsp;
          <span
            className="font-medium text-[0.8rem] text-[#F7542E] cursor-pointer"
            onClick={resendHandler}
          >
            RESEND
          </span>
        </p>
        <p
          className={`mt-4 text-center text-[0.85rem] ${show ? "" : "hidden"}`}
        >
          Code has been sent. Resend code in &nbsp;
          <span className="font-semibold text-[#F7542E] cursor-pointer">
            {seconds}s
          </span>
        </p>
        <button
          onClick={checkHandler}
          className="w-full bg-primary text-white p-3 text-medium text-[1.1rem] rounded-lg mt-4"
        >
          Verify
        </button>
      </div>
      <div
        className={`${
          show1 ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="relative rounded-xl w-[20rem] pb-6 flex items-center p-3 bg-white flex-col">
          <div
            className="absolute top-[-11%] left-[42%]"
            onClick={() => setShow1(false)}
          >
            <img src={across} alt="" />
          </div>
          <p className="text-center mt-[3rem] mb-5">{err}</p>
          <button
            onClick={() => setShow1(false)}
            className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[60%]"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export default Vppopup;
